import { authRepository } from "../repository/AuthRepository";

export const authService = {
  login: async (details, onSuccess, onError) => {
    authRepository
      .login(details)
      .then((res) => {
        localStorage.setItem("authToken", res.data.token);
        localStorage.setItem("email", res.data.email);
        onSuccess(res.data);
      })
      .catch((err) => {
        console.log(err);
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  logout: async (onSuccess, onError) => {
    try {
      await new Promise((resolve, reject) => {
        try {
          localStorage.removeItem("email");
          localStorage.removeItem("authToken");
          resolve();
        } catch (err) {
          reject(err);
        }
      });
      onSuccess("Successfully Logged Out");
    } catch (error) {
      onError("Error Logging Out");
    }
  },
};
